(function(window) {
  'use strict';

  const hasValue = (v) => typeof v === 'string' ? v.trim() !== '' : v != null;
  const toNormalizedText = (v) => String(v || '').trim().toLowerCase();
  const anyMatch = (value, patterns) => {
    const text = toNormalizedText(value);
    return text && patterns.some((pattern) => pattern.test(text));
  };

  function isArchivedReservation(reservation) {
    if (!reservation) return false;
    if (reservation.archived === true) return true;
    const cancellationPatterns = [
      /cancel/,
      /cancell?ed/,
      /キャンセル/,
      /cancelled/,
      /cancellation/
    ];
    return anyMatch(reservation.status, cancellationPatterns)
      || anyMatch(reservation.reservationStatus, cancellationPatterns)
      || anyMatch(reservation.adminStatus, cancellationPatterns);
  }

  function isConfirmedReservation(reservation, calendarEvents) {
    if (!reservation) return false;
    const confirmedPatterns = [
      /confirmed/,
      /reservation_confirmed/,
      /complete/,
      /completed/,
      /確定/,
      /対応済/,
      /当日対応注意/
    ];
    const hasConfirmedStatus = anyMatch(reservation.status, confirmedPatterns)
      || anyMatch(reservation.reservationStatus, confirmedPatterns)
      || anyMatch(reservation.adminStatus, confirmedPatterns);
    const hasCalendarReference = hasValue(reservation.calendarEventId)
      || hasValue(reservation.calendarEventUrl)
      || hasValue(reservation.calendarId)
      || hasValue(reservation.createdCalendarEventId)
      || hasValue(reservation.createdCalendarEventUrl);
    const hasConfirmedDate = hasValue(reservation.reservationStartAt)
      || hasValue(reservation.trueDate)
      || hasValue(reservation.rsvdate)
      || hasValue(reservation.schedule1);
    const hasConfirmedCalendarEvent = Array.isArray(calendarEvents) && calendarEvents.some((ev) => (
      hasValue(ev?.eventId)
      || hasValue(ev?.eventUrl)
      || hasValue(ev?.calendarId)
      || hasValue(ev?.startTime)
    ));
    return hasConfirmedStatus || hasCalendarReference || hasConfirmedDate || hasConfirmedCalendarEvent;
  }

  function isTentativeReservation(reservation, calendarEvents, statusFromApi) {
    if (!reservation) return false;
    const evs = Array.isArray(calendarEvents) ? calendarEvents : [];
    const tentativePattern = /(新規・仮|仮|tentative)/i;
    if (reservation?.isTentative === true && !isConfirmedReservation(reservation, evs)) return true;
    if (statusFromApi && tentativePattern.test(String(statusFromApi)) && !isConfirmedReservation(reservation, evs)) return true;
    if (tentativePattern.test(String(reservation?.status || '')) && !isConfirmedReservation(reservation, evs)) return true;
    if (tentativePattern.test(String(reservation?.reservationStatus || '')) && !isConfirmedReservation(reservation, evs)) return true;
    return evs.some((ev) => tentativePattern.test(String(ev?.eventTitle || '')));
  }

  function resolveReservationDisplayStatus(reservation, calendarEvents, statusFromApi) {
    const op = String(reservation?.operationStatusText || '');
    const adminStatus = String(reservation?.adminStatus || '');
    const statusText = `${op} ${adminStatus} ${reservation?.resolvedAdminStatus || ''} ${reservation?.displayStatus || ''} ${reservation?.displayStatusLabel || ''} ${reservation?.status || ''} ${reservation?.reservationStatus || ''} ${statusFromApi || ''}`;
    if (isArchivedReservation(reservation)) return 'cancelled';
    if (/当日対応注意/.test(statusText)) return 'confirmed';
    if (isConfirmedReservation(reservation, calendarEvents)) return 'confirmed';
    if ((op + ' ' + adminStatus).includes('不可')) return 'unavailable';
    if (isTentativeReservation(reservation, calendarEvents, statusFromApi)) return 'tentative';
    return 'pending';
  }

  window.ReservationStatusShared = {
    isArchivedReservation,
    isConfirmedReservation,
    isTentativeReservation,
    resolveReservationDisplayStatus
  };
})(window);
